import React, { useEffect } from "react";
import Router from "./routes/Router";
import { useSelector } from "react-redux";
import LoaderBackdrop from "./components/ui/LoaderBackdrop";
import { clearAppCache } from "./utils/cache";
import { decrypt } from "./utils/crypto";
import DialogStatusPopup from "./components/common/DialogStatusPopup";
import {
  initAnalytics,
  setAnalyticsContext,
  usePageTracking,
} from "./utils/analytics";
import { useLocation } from "react-router-dom";

function App() {
  const location = useLocation();
  const userId = useSelector((state: any) => state?.auth?.userProfile?.id);
  const globalLoading = useSelector(
    (state: any) => state?.loading?.globalLoading
  );

  if((sessionStorage.getItem("isThirdPartyVisited") ||
    sessionStorage.getItem("redirectThrough")) &&
    location.pathname !== "/application/upload-document") {
    sessionStorage.removeItem("isThirdPartyVisited");
    sessionStorage.removeItem("redirectThrough");
  }

  // Single init, no duplication
  useEffect(() => {
    initAnalytics();
  }, []);

  // Page view tracking on route change
  usePageTracking();

  // Set user context when auth state changes (auto-attached to events)
  useEffect(() => {
    if (userId) {
      setAnalyticsContext({ user_id: decrypt(userId) });
    } else {
      setAnalyticsContext({ user_id: "" });
    }
  }, [userId]);

  useEffect(() => {
    clearAppCache();
  }, []);

  return (
    <>
      <LoaderBackdrop open={globalLoading} />
      <Router />
      <DialogStatusPopup />
    </>
  );
}

export default App;
